import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiInput from "components/VuiInput";
import VuiButton from "components/VuiButton";
import { useEffect, useState } from "react";
import { FaPlus, FaStickyNote, FaTimes } from "react-icons/fa";
import useCommon from "hooks/useCommon";
import NotesColumn from "./utils/NotesColumn";
import dayjs from "dayjs";
import { getGuestReservationNotes } from "../../../../store/slice/guestSlice";
import OverlayLoader from "components/OverlayLoader";

const formatDate = (date) => (date ? dayjs(date).format("MMM D, YYYY") : "—");

const GuestNotesDialog = ({ open, onClose, guest }) => {
  if (!guest) return null;

  const { DISPATCH, STORE } = useCommon();

  const hotelIds = STORE((state) => state.ui.hotelIds);
  const { guestNotes, guestNotesLoading } = STORE((state) => state.guests);

  const [search, setSearch] = useState("");

  const arrivalNotes =
    (guestNotes?.arrival_note || []).map((note) => ({
      text: note.text,
      type: "arrival",
      staff: note.authorName,
      date: note.createdAt,
      stayDuration:
        note?.stay?.checkInDate && note?.stay?.checkOutDate
          ? `${formatDate(note.stay.checkInDate)} → ${formatDate(note.stay.checkOutDate)}`
          : null,
    })) || [];

  const staffNotes =
    (guestNotes?.staff_note || []).map((note) => ({
      text: note.text,
      type: "staff",
      staff: note.authorName,
      date: note.createdAt,
      stayDuration:
        note?.stay?.checkInDate && note?.stay?.checkOutDate
          ? `${formatDate(note.stay.checkInDate)} → ${formatDate(note.stay.checkOutDate)}`
          : null,
    })) || [];

  const pmsNotes =
    (guestNotes?.pms_note || []).map((note) => ({
      text: note.text,
      type: "pms",
      staff: note.authorName,
      date: note.createdAt,
      stayDuration:
        note?.stay?.checkInDate && note?.stay?.checkOutDate
          ? `${formatDate(note.stay.checkInDate)} → ${formatDate(note.stay.checkOutDate)}`
          : null,
    })) || [];

  const filterNotes = (notes) =>
    notes.filter(
      (note) =>
        note.text.toLowerCase().includes(search.toLowerCase()) ||
        (note.staff && note.staff.toLowerCase().includes(search.toLowerCase()))
    );

  useEffect(() => {
    if (!open || !guest?.id || !hotelIds?.length) return;

    DISPATCH(
      getGuestReservationNotes({
        guestId: guest.id,
        hotelIds,
      })
    );
  }, [open, guest?.id, hotelIds, DISPATCH]);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose();
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <VuiTypography variant="h6">Notes History</VuiTypography>

        <IconButton onClick={onClose}>
          <FaTimes size={14} color="#fff" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* <VuiBox display="flex" justifyContent="end" mb={2}>
          <VuiBox sx={{ width: 240 }}>
            <VuiInput
              fullWidth
              placeholder="Search notes..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              icon={{ component: "search", direction: "left" }}
            />
          </VuiBox>
        </VuiBox> */}

        <OverlayLoader open={guestNotesLoading} message="Loading notes..." />

        <VuiBox display="grid" gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))" gap={1.5}>
          {arrivalNotes.length > 0 && (
            <NotesColumn
              title="Arrival Notes"
              notes={filterNotes(arrivalNotes)}
              type="arrival"
              emptyMessage="No matching arrival notes found."
            />
          )}

          {staffNotes.length > 0 && (
            <NotesColumn
              title="Staff Notes"
              notes={filterNotes(staffNotes)}
              type="staff"
              emptyMessage="No matching staff notes found."
            />
          )}

          {pmsNotes.length > 0 && (
            <NotesColumn
              title="PMS Notes"
              notes={filterNotes(pmsNotes)}
              type="pms"
              emptyMessage="No matching PMS notes found."
            />
          )}
        </VuiBox>
      </DialogContent>
    </Dialog>
  );
};

export default GuestNotesDialog;
